var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapsule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2843 3.71573C17.9966 1.42809 14.2876 1.42809 12 3.71573L8.38831 7.32743L16.6726 15.6117L20.2843 12C22.5719 9.71236 22.5719 6.00337 20.2843 3.71573Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6119 16.6724L7.32764 8.38809L3.71573 12C1.42809 14.2876 1.42809 17.9966 3.71573 20.2843C6.00337 22.5719 9.71236 22.5719 12 20.2843L15.6119 16.6724Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsule);
export default __webpack_public_path__ + "static/media/capsule.c574f199c84e184399eaa8442556ca2f.svg";
export { ForwardRef as ReactComponent };